import React from "react";
import { Card, Modal, CloseButton } from "react-bootstrap";

const DynamicModal = ({
  title,
  show,
  onHide = () => {},
  children,
  size = "xl",
  centered = true,
  hideCloseButton = false,
  footer = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered={centered}
      backdrop="static"
      keyboard={false}
    >
      <Card className="p-0 h-100 w-100">
        <Card.Header className="bg-light p-3 d-flex justify-content-between align-items-center">
          <p
            className="m-0 ms-2 fw-semibold"
            style={{ fontSize: "1rem", fontWeight: "600" }}
          >
           Hello
          </p>
          {!hideCloseButton && (
            <CloseButton variant="light" onClick={onHide} aria-label="Close" />
          )}
        </Card.Header>
        <Card.Body>
          <>
            {children ? (
              children
            ) : (
              <p className="text-muted text-center fw-semibold">No Data</p>
            )}
          </>
        </Card.Body>
        {footer && (
          <Card.Footer
            className="bg-light text-center text-muted fw-semibold"
            style={{ fontSize: "0.9rem" }}
          >
            {footer}
          </Card.Footer>
        )}
      </Card>
    </Modal>
  );
};

export default DynamicModal;
